import { FileText, TrendingUp, Layers, Star, BarChart3, Scale } from "lucide-react";

const factors = [
  { label: "Document volume", desc: "Number of filings in the record" },
  { label: "Record complexity", desc: "Full, partial, sealed, or multi-volume" },
  { label: "Turnaround speed", desc: "Standard vs. expedited delivery" },
  { label: "Court requirements", desc: "Jurisdiction-specific formatting" },
];

export default function BusinessModelSlide() {
  return (
    <div
      className="h-full w-full flex flex-col p-7 sm:p-10 lg:p-12"
      data-testid="slide-businessmodel-content"
    >
      <span className="text-sm font-bold tracking-[0.2em] uppercase text-blue-600 mb-2 font-body">
        BUSINESS MODEL
      </span>
      <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter text-slate-900 mb-6 leading-tight">
        Per-appeal pricing with strong margins
      </h1>

      <div className="flex-1 flex flex-col md:flex-row gap-5 sm:gap-8 min-h-0">
        <div className="md:w-[320px] shrink-0">
          <div className="rounded-xl border-2 border-blue-600 bg-blue-50/50 p-5 sm:p-6 h-full flex flex-col">
            <div className="flex items-center gap-2 mb-4">
              <FileText className="h-4 w-4 text-blue-600" />
              <span className="text-xs font-bold tracking-[0.1em] uppercase text-blue-600 font-heading">
                Per Appeal
              </span>
            </div>
            <div className="text-3xl sm:text-4xl font-black text-slate-900 font-heading mb-1">
              $500 &ndash; $5,000
            </div>
            <div className="text-xs text-slate-500 font-body mb-6">
              per record on appeal
            </div>
            <div className="space-y-2 mt-auto">
              <div className="text-sm text-slate-600 font-body flex items-start gap-2">
                <div className="w-1 h-1 rounded-full bg-blue-600 mt-1.5 shrink-0" />
                Price scales with record complexity
              </div>
              <div className="text-sm text-slate-600 font-body flex items-start gap-2">
                <div className="w-1 h-1 rounded-full bg-blue-600 mt-1.5 shrink-0" />
                Significant savings vs. $5K&ndash;$20K manual costs
              </div>
              <div className="text-sm text-slate-600 font-body flex items-start gap-2">
                <div className="w-1 h-1 rounded-full bg-blue-600 mt-1.5 shrink-0" />
                Multiple appeals per firm per year create repeat usage
              </div>
            </div>
          </div>
        </div>

        <div className="flex-1 flex flex-col justify-center">
          <div className="text-[11px] font-bold tracking-[0.15em] uppercase text-slate-400 mb-3 font-body">
            Pricing Factors
          </div>
          <div className="space-y-2.5 sm:space-y-3">
            {factors.map((f, i) => (
              <div
                key={i}
                className="flex items-center gap-3 bg-slate-50 rounded-lg p-3 border border-slate-100"
              >
                <div className="w-7 h-7 bg-blue-50 rounded flex items-center justify-center shrink-0">
                  <span className="text-xs font-bold text-blue-600 font-mono">
                    {i + 1}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-slate-900 font-heading">
                    {f.label}
                  </div>
                  <div className="text-sm text-slate-500 font-body">
                    {f.desc}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-2 md:gap-6 sm:gap-8 mt-4 md:mt-5 justify-center">
        {[
          { icon: TrendingUp, text: "Repeat usage per firm per year" },
          { icon: Layers, text: "High-margin software model" },
          { icon: Star, text: "Premium features over time" },
        ].map((item, i) => (
          <div key={i} className="flex items-center gap-1.5">
            <item.icon className="h-3 w-3 text-slate-400" />
            <span className="text-sm text-slate-500 font-body">
              {item.text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
